import { IComponentSharedLink, IPageEntityResponse, IStoryEntityResponse } from '@/graphql/__generated__/global/types';
import { isFullUrl } from '@/lib/getImageUrl';
import { findFullSlug } from '@/lib/strapiQueries';
import Link from 'next/link';

export const isValidLink = (linkToPage?: IPageEntityResponse, linkToStory?: IStoryEntityResponse, linkToExternalPage?: string) => {
    return linkToPage?.data || linkToStory?.data || linkToExternalPage;
};

export const findHref = (linkToPage?: IPageEntityResponse, linkToStory?: IStoryEntityResponse, linkToExternalPage?: string) => {
    let href = '';
    if (linkToPage || linkToStory || linkToExternalPage) {
        switch (true) {
            case Boolean(linkToPage?.data):
                href = findFullSlug(linkToPage?.data).join('/');
                break;
            case Boolean(linkToStory?.data):
                href = findFullSlug(linkToStory?.data).join('/');
                break;
            case Boolean(linkToExternalPage):
                href = linkToExternalPage || '';
                break;
        }
    }

    return href;
};

const LinkRenderer = ({
    children,
    className,
    rel,
    linkToPage,
    linkToStory,
    linkToExternalPage,
    forceTarget,
    onClick,
}: Partial<IComponentSharedLink> & {
    children?: React.ReactNode;
    className?: string;
    rel?: string;
    forceTarget?: string;
    onClick?: () => void;
}) => {
    if (!isValidLink(linkToPage, linkToStory, linkToExternalPage)) {
        return <>{children}</>;
    }

    const href = findHref(linkToPage, linkToStory, linkToExternalPage);
    let target;
    if (!forceTarget) {
        target = linkToExternalPage && isFullUrl(linkToExternalPage) ? '_blank' : '_self';
    } else {
        target = forceTarget;
    }

    return (
        <Link className={className} target={target ? target : '_self'} href={href} passHref rel={rel} onClick={onClick} prefetch={false}>
            {children}
        </Link>
    );
};

export { LinkRenderer };
